// For the sake of this demo, we have to use debounce to reduce Google Maps Places API quote use
// But prefer to use throttle in practice
// import throttle from 'lodash/throttle';
import { debounce } from "@mui/material/utils";

export const fetchGooglePlacePrediction: (
    requestValues: { input: string, language?: string },
    sessionToken: google.maps.places.AutocompleteSessionToken,
    callback: (results?: readonly google.maps.places.PlacePrediction[]) => void
) => void = debounce(async (
        requestValues: { input: string; language?: string },
        sessionToken: google.maps.places.AutocompleteSessionToken,
        callback: (results?: readonly google.maps.places.PlacePrediction[]) => void,
    ) => {
        const request: google.maps.places.AutocompleteRequest = {
            input: requestValues.input,
            sessionToken: sessionToken,
        }
        const { suggestions } = await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
        const placePredictions: google.maps.places.PlacePrediction[] = [];
        suggestions.map(
            (suggestion: google.maps.places.AutocompleteSuggestion) => {
                if (suggestion.placePrediction !== null) {
                    placePredictions.push(suggestion.placePrediction);
                }
            }
        );

        callback(placePredictions);
    },
    400,
);

export const fetchGeocodingFromPlaceId = async (
    placeId: string,
    callback: (results: readonly google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatusString) => void
) => {
    const geocoder = new google.maps.Geocoder();
    await geocoder.geocode({ placeId: placeId } as google.maps.GeocoderRequest, callback);
}